import { render } from "./gopay.vue?vue&type=template&id=7f025612&scoped=true"
import script from "./gopay.vue?vue&type=script&lang=js"
export * from "./gopay.vue?vue&type=script&lang=js"

import "./gopay.vue?vue&type=style&index=0&id=7f025612&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f025612"]])

export default __exports__